<template>
  <div>
    <div v-if="!submittedSuccessfully" class="py-4 px-lg-5 px-md-2">
      <div class="row">
        <div class="d-none col text-center mb-5">
          <h2 :style="{ color: 'rgba(0, 0, 0, 0.5)' }">Contact Us</h2>
        </div>
      </div>
      <div class="row mt-3 mb-4">
        <div class="col-12 col-md-6 mt-md-4 mb-auto text-center" style="white-space: pre-line">
          <img
            :src="company.logoLink && !company.logoLink.includes('gravatar') ? company.logoLink : '/img/icons/no-company.png'"
            :alt="company.name"
            class="img-fluid company-logo-image mb-2"
          />
          <h5 class="text-center text-primary px-md-3 px-lg-5 text-black-50 mb-5 mb-md-0">
            {{ company.public_profile_contact_statement }}
          </h5>
        </div>
        <div class="col-12 col-md-5 p-5 border rounded bg-white small">
          <div class="p-3">
            <h3 class="mb-4" :style="{ color: 'rgba(0, 0, 0, 0.5)' }">Contact Us</h3>
            <BushelTextInput v-model="form.company_name" type="text" :error="submitted && !form.company_name" thin :label-active="'Company Name'" />
            <BushelTextInput v-model="form.contact_name" type="text" thin :error="submitted && !form.contact_name" :label-active="'Contact Name'" />
            <BushelTextInput v-model="form.email" type="text" thin :error="submitted && !validateEmail(form.email)" :label-active="'Contact Email'" />
            <BushelTextInput v-model="form.phone" type="text" thin :label-active="'Contact Phone'" />
            <!--
          </div>
          <div class="col-12 col-md-6">
          -->
            <BushelTextArea
              v-model="form.message"
              :error="submitted && !form.message"
              type="text"
              :rows="3"
              thin
              :label-active="'Message'"
              class="flex-grow-1"
            />
            <BushelBtn variant="success" ripple-color="success" class="btn-block py-2 mt-4" :disabled="submitting" @click="sendContact">
              Submit
            </BushelBtn>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col">
          <BushelBtn
            variant="success"
            ripple-color="success"
            outline
            block
            @click="sendContact"
          >
            Update
          </BushelBtn>
        </div>
      </div> -->
    </div>
    <Checkmark v-else class="m-5" :title="'Message Sent'" />
  </div>
</template>

<script>
import * as api from "@/services/api";
import Checkmark from "@/components/common/Checkmark.vue";
import { validateEmail } from "@/services/helpers";

export default {
  components: { Checkmark },
  props: {
    company: { type: Object, required: true },
    user: { type: Object },
  },

  data() {
    return {
      submitted: false,
      submittedSuccessfully: false,
      submitting: false,
      form: {
        company_id: this.company.id,
        message: "",
        phone: this.user ? this.user.phone : "",
        email: this.user ? this.user.email : "",
        contact_name: this.user ? this.user.name : "",
        company_name: this.user && this.user.current_company ? this.user.current_company.name : "",
        requesting_company_id: this.user && this.user.current_company ? this.user.current_company.id : null,
        source: "Storefront",
      },
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    validateEmail,
    sendContact() {
      this.submitted = true;
      if (this.form.message && this.validateEmail(this.form.email) && this.form.contact_name && this.form.company_name) {
        const that = this;
        this.submitting = true;
        api.post("storefront-messages", this.form).then(
          (response) => {
            that.submittedSuccessfully = true;
            that.submitting = false;
          },
          (error) => {
            // problem
          },
        );
      }
    },
  },
};
</script>

<style scoped>
.company-logo-image {
  max-height: 120px;
  width: auto;
}
</style>
